import { render, staticRenderFns } from "./UserManagementView.vue?vue&type=template&id=2ed1824a&"
import script from "./UserManagementView.vue?vue&type=script&lang=js&"
export * from "./UserManagementView.vue?vue&type=script&lang=js&"
import style0 from "./UserManagementView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports